// THEME
import theme from '@/theme/materialTheme';

export const { breakpoints } = theme;

export default breakpoints;
